/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * AGOS API
 * v1 is a faithful port of the HellKitchen Express API: same paths under /api/v1, same request and response shapes, same status codes and error messages.
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type {
  ActivePromo,
  Campaign,
  CampaignDeleted,
  CampaignRunOutcome,
  CampaignRunRow,
  CampaignSendCap,
  CampaignWritten,
  CmsPage,
  CmsPageRemoved,
  CmsPageSummary,
  CustomerWheel,
  GetLoyaltyLeaderboardParams,
  GetMiniGameStatsParams,
  GetNewsletterSubscribersParams,
  GetTranslationsDictParams,
  GetTranslationsParams,
  GoogleRating,
  HappyHoursPublic,
  HomepageModule,
  HomepageModuleDeleted,
  HomepageModulesSeeded,
  Leaderboard,
  LeaderboardHistory,
  LeaderboardRunOutcome,
  ManualSmsSend,
  MiniGamePlayResult,
  MiniGameStats,
  MiniGameStatus,
  NewsletterSubscribed,
  NewsletterSubscriberPage,
  NewsletterSubscriberRemoved,
  PatchCampaignsIdIdBody,
  PatchCampaignsSendCapBody,
  PatchCampaignsTypeBody,
  PatchCampaignsWheelBody,
  PatchTranslationsIdBody,
  PostCampaignsBody,
  PostCampaignsIdIdRunBody,
  PostCampaignsTypeRunBody,
  PostHomepageModulesBody,
  PostLoyaltyLeaderboardRunBody,
  PostMiniGamePlayBody,
  PostNewsletterSubscribeBody,
  PostSettingsSmsBody,
  PostSettingsSmsTestBody,
  PostSmsSendManualBody,
  PostTranslationsBulkDeleteBody,
  PostTranslationsMissingBody,
  PostTranslationsTranslateAllMissingBody,
  PutCmsPagesSlugBody,
  PutHomepageModulesBulkBody,
  PutHomepageModulesKeyBody,
  SmsSettings,
  SmsTestResult,
  TranslationDictionaryResponse,
  TranslationOverridden,
  TranslationPage,
  TranslationRemoved,
  TranslationStats,
  TranslationSweepStarted,
  TranslationSweepStatus,
  TranslationsFilled,
  TranslationsRemoved,
  WheelSettings,
  WheelSpinResult,
} from '../../model'

import { customFetch } from '../../../custom-fetch'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const getPutHomepageModulesKeyUrl = (key: string) => {
  return `/api/v1/homepage-modules/${key}`
}

/**
 * @summary Change a block
 */
export const putHomepageModulesKey = async (
  key: string,
  putHomepageModulesKeyBody: PutHomepageModulesKeyBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<HomepageModule> => {
  return customFetch<HomepageModule>(getPutHomepageModulesKeyUrl(key), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putHomepageModulesKeyBody),
  })
}

export const getPutHomepageModulesKeyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putHomepageModulesKey>>,
    TError,
    { key: string; data: PutHomepageModulesKeyBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putHomepageModulesKey>>,
  TError,
  { key: string; data: PutHomepageModulesKeyBody },
  TContext
> => {
  const mutationKey = ['putHomepageModulesKey']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putHomepageModulesKey>>,
    { key: string; data: PutHomepageModulesKeyBody }
  > = (props) => {
    const { key, data } = props ?? {}

    return putHomepageModulesKey(key, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutHomepageModulesKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof putHomepageModulesKey>>
>
export type PutHomepageModulesKeyMutationBody = PutHomepageModulesKeyBody
export type PutHomepageModulesKeyMutationError = unknown

/**
 * @summary Change a block
 */
export const usePutHomepageModulesKey = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putHomepageModulesKey>>,
      TError,
      { key: string; data: PutHomepageModulesKeyBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putHomepageModulesKey>>,
  TError,
  { key: string; data: PutHomepageModulesKeyBody },
  TContext
> => {
  return useMutation(getPutHomepageModulesKeyMutationOptions(options), queryClient)
}
export const getDeleteHomepageModulesKeyUrl = (key: string) => {
  return `/api/v1/homepage-modules/${key}`
}

/**
 * @summary Remove a block
 */
export const deleteHomepageModulesKey = async (
  key: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<HomepageModuleDeleted> => {
  return customFetch<HomepageModuleDeleted>(getDeleteHomepageModulesKeyUrl(key), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteHomepageModulesKeyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteHomepageModulesKey>>,
    TError,
    { key: string },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteHomepageModulesKey>>,
  TError,
  { key: string },
  TContext
> => {
  const mutationKey = ['deleteHomepageModulesKey']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteHomepageModulesKey>>,
    { key: string }
  > = (props) => {
    const { key } = props ?? {}

    return deleteHomepageModulesKey(key, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteHomepageModulesKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteHomepageModulesKey>>
>

export type DeleteHomepageModulesKeyMutationError = unknown

/**
 * @summary Remove a block
 */
export const useDeleteHomepageModulesKey = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteHomepageModulesKey>>,
      TError,
      { key: string },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteHomepageModulesKey>>,
  TError,
  { key: string },
  TContext
> => {
  return useMutation(getDeleteHomepageModulesKeyMutationOptions(options), queryClient)
}
export const getPutHomepageModulesBulkUrl = () => {
  return `/api/v1/homepage-modules-bulk`
}

/**
 * @summary Reorder the whole homepage
 */
export const putHomepageModulesBulk = async (
  putHomepageModulesBulkBody: PutHomepageModulesBulkBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<HomepageModule[]> => {
  return customFetch<HomepageModule[]>(getPutHomepageModulesBulkUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putHomepageModulesBulkBody),
  })
}

export const getPutHomepageModulesBulkMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putHomepageModulesBulk>>,
    TError,
    { data: PutHomepageModulesBulkBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putHomepageModulesBulk>>,
  TError,
  { data: PutHomepageModulesBulkBody },
  TContext
> => {
  const mutationKey = ['putHomepageModulesBulk']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putHomepageModulesBulk>>,
    { data: PutHomepageModulesBulkBody }
  > = (props) => {
    const { data } = props ?? {}

    return putHomepageModulesBulk(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutHomepageModulesBulkMutationResult = NonNullable<
  Awaited<ReturnType<typeof putHomepageModulesBulk>>
>
export type PutHomepageModulesBulkMutationBody = PutHomepageModulesBulkBody
export type PutHomepageModulesBulkMutationError = unknown

/**
 * @summary Reorder the whole homepage
 */
export const usePutHomepageModulesBulk = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putHomepageModulesBulk>>,
      TError,
      { data: PutHomepageModulesBulkBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putHomepageModulesBulk>>,
  TError,
  { data: PutHomepageModulesBulkBody },
  TContext
> => {
  return useMutation(getPutHomepageModulesBulkMutationOptions(options), queryClient)
}
export const getGetCmsPagesSlugUrl = (slug: string) => {
  return `/api/v1/cms-pages/${slug}`
}

/**
 * @summary One page
 */
export const getCmsPagesSlug = async (
  slug: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<CmsPage> => {
  return customFetch<CmsPage>(getGetCmsPagesSlugUrl(slug), {
    ...options,
    method: 'GET',
  })
}

export const getGetCmsPagesSlugQueryKey = (slug: string) => {
  return [`/api/v1/cms-pages/${slug}`] as const
}

export const getGetCmsPagesSlugQueryOptions = <
  TData = Awaited<ReturnType<typeof getCmsPagesSlug>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsPagesSlug>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCmsPagesSlugQueryKey(slug)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCmsPagesSlug>>> = ({ signal }) =>
    getCmsPagesSlug(slug, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: slug !== null && slug !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getCmsPagesSlug>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetCmsPagesSlugQueryResult = NonNullable<Awaited<ReturnType<typeof getCmsPagesSlug>>>
export type GetCmsPagesSlugQueryError = unknown

export function useGetCmsPagesSlug<
  TData = Awaited<ReturnType<typeof getCmsPagesSlug>>,
  TError = unknown,
>(
  slug: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsPagesSlug>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCmsPagesSlug>>,
          TError,
          Awaited<ReturnType<typeof getCmsPagesSlug>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCmsPagesSlug<
  TData = Awaited<ReturnType<typeof getCmsPagesSlug>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsPagesSlug>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCmsPagesSlug>>,
          TError,
          Awaited<ReturnType<typeof getCmsPagesSlug>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCmsPagesSlug<
  TData = Awaited<ReturnType<typeof getCmsPagesSlug>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsPagesSlug>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One page
 */

export function useGetCmsPagesSlug<
  TData = Awaited<ReturnType<typeof getCmsPagesSlug>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsPagesSlug>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCmsPagesSlugQueryOptions(slug, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutCmsPagesSlugUrl = (slug: string) => {
  return `/api/v1/cms-pages/${slug}`
}

/**
 * @summary Write a page
 */
export const putCmsPagesSlug = async (
  slug: string,
  putCmsPagesSlugBody: PutCmsPagesSlugBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<CmsPage> => {
  return customFetch<CmsPage>(getPutCmsPagesSlugUrl(slug), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putCmsPagesSlugBody),
  })
}

export const getPutCmsPagesSlugMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCmsPagesSlug>>,
    TError,
    { slug: string; data: PutCmsPagesSlugBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putCmsPagesSlug>>,
  TError,
  { slug: string; data: PutCmsPagesSlugBody },
  TContext
> => {
  const mutationKey = ['putCmsPagesSlug']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putCmsPagesSlug>>,
    { slug: string; data: PutCmsPagesSlugBody }
  > = (props) => {
    const { slug, data } = props ?? {}

    return putCmsPagesSlug(slug, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutCmsPagesSlugMutationResult = NonNullable<Awaited<ReturnType<typeof putCmsPagesSlug>>>
export type PutCmsPagesSlugMutationBody = PutCmsPagesSlugBody
export type PutCmsPagesSlugMutationError = unknown

/**
 * @summary Write a page
 */
export const usePutCmsPagesSlug = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putCmsPagesSlug>>,
      TError,
      { slug: string; data: PutCmsPagesSlugBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putCmsPagesSlug>>,
  TError,
  { slug: string; data: PutCmsPagesSlugBody },
  TContext
> => {
  return useMutation(getPutCmsPagesSlugMutationOptions(options), queryClient)
}
export const getDeleteCmsPagesSlugUrl = (slug: string) => {
  return `/api/v1/cms-pages/${slug}`
}

/**
 * @summary Remove a page
 */
export const deleteCmsPagesSlug = async (
  slug: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<CmsPageRemoved> => {
  return customFetch<CmsPageRemoved>(getDeleteCmsPagesSlugUrl(slug), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteCmsPagesSlugMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCmsPagesSlug>>,
    TError,
    { slug: string },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCmsPagesSlug>>,
  TError,
  { slug: string },
  TContext
> => {
  const mutationKey = ['deleteCmsPagesSlug']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCmsPagesSlug>>,
    { slug: string }
  > = (props) => {
    const { slug } = props ?? {}

    return deleteCmsPagesSlug(slug, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteCmsPagesSlugMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCmsPagesSlug>>
>

export type DeleteCmsPagesSlugMutationError = unknown

/**
 * @summary Remove a page
 */
export const useDeleteCmsPagesSlug = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCmsPagesSlug>>,
      TError,
      { slug: string },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCmsPagesSlug>>,
  TError,
  { slug: string },
  TContext
> => {
  return useMutation(getDeleteCmsPagesSlugMutationOptions(options), queryClient)
}
export const getPostTranslationsTranslateAllMissingUrl = () => {
  return `/api/v1/translations/translate-all-missing`
}

/**
 * @summary Fill every gap in the memory - this spends the AI budget
 */
export const postTranslationsTranslateAllMissing = async (
  postTranslationsTranslateAllMissingBody?: PostTranslationsTranslateAllMissingBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<TranslationSweepStarted> => {
  return customFetch<TranslationSweepStarted>(getPostTranslationsTranslateAllMissingUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postTranslationsTranslateAllMissingBody),
  })
}

export const getPostTranslationsTranslateAllMissingMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTranslationsTranslateAllMissing>>,
    TError,
    { data?: PostTranslationsTranslateAllMissingBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTranslationsTranslateAllMissing>>,
  TError,
  { data?: PostTranslationsTranslateAllMissingBody },
  TContext
> => {
  const mutationKey = ['postTranslationsTranslateAllMissing']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTranslationsTranslateAllMissing>>,
    { data?: PostTranslationsTranslateAllMissingBody }
  > = (props) => {
    const { data } = props ?? {}

    return postTranslationsTranslateAllMissing(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostTranslationsTranslateAllMissingMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTranslationsTranslateAllMissing>>
>
export type PostTranslationsTranslateAllMissingMutationBody =
  PostTranslationsTranslateAllMissingBody | undefined
export type PostTranslationsTranslateAllMissingMutationError = unknown

/**
 * @summary Fill every gap in the memory - this spends the AI budget
 */
export const usePostTranslationsTranslateAllMissing = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postTranslationsTranslateAllMissing>>,
      TError,
      { data?: PostTranslationsTranslateAllMissingBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postTranslationsTranslateAllMissing>>,
  TError,
  { data?: PostTranslationsTranslateAllMissingBody },
  TContext
> => {
  return useMutation(getPostTranslationsTranslateAllMissingMutationOptions(options), queryClient)
}
export const getPostTranslationsMissingUrl = () => {
  return `/api/v1/translations/missing`
}

/**
 * @summary Translate a page's worth of strings, filling gaps
 */
export const postTranslationsMissing = async (
  postTranslationsMissingBody: PostTranslationsMissingBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<TranslationsFilled> => {
  return customFetch<TranslationsFilled>(getPostTranslationsMissingUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postTranslationsMissingBody),
  })
}

export const getPostTranslationsMissingMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTranslationsMissing>>,
    TError,
    { data: PostTranslationsMissingBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTranslationsMissing>>,
  TError,
  { data: PostTranslationsMissingBody },
  TContext
> => {
  const mutationKey = ['postTranslationsMissing']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTranslationsMissing>>,
    { data: PostTranslationsMissingBody }
  > = (props) => {
    const { data } = props ?? {}

    return postTranslationsMissing(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostTranslationsMissingMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTranslationsMissing>>
>
export type PostTranslationsMissingMutationBody = PostTranslationsMissingBody
export type PostTranslationsMissingMutationError = unknown

/**
 * @summary Translate a page's worth of strings, filling gaps
 */
export const usePostTranslationsMissing = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postTranslationsMissing>>,
      TError,
      { data: PostTranslationsMissingBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postTranslationsMissing>>,
  TError,
  { data: PostTranslationsMissingBody },
  TContext
> => {
  return useMutation(getPostTranslationsMissingMutationOptions(options), queryClient)
}
export const getPostTranslationsBulkDeleteUrl = () => {
  return `/api/v1/translations/bulk-delete`
}

/**
 * @summary Remove many translations
 */
export const postTranslationsBulkDelete = async (
  postTranslationsBulkDeleteBody: PostTranslationsBulkDeleteBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<TranslationsRemoved> => {
  return customFetch<TranslationsRemoved>(getPostTranslationsBulkDeleteUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postTranslationsBulkDeleteBody),
  })
}

export const getPostTranslationsBulkDeleteMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTranslationsBulkDelete>>,
    TError,
    { data: PostTranslationsBulkDeleteBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTranslationsBulkDelete>>,
  TError,
  { data: PostTranslationsBulkDeleteBody },
  TContext
> => {
  const mutationKey = ['postTranslationsBulkDelete']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTranslationsBulkDelete>>,
    { data: PostTranslationsBulkDeleteBody }
  > = (props) => {
    const { data } = props ?? {}

    return postTranslationsBulkDelete(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostTranslationsBulkDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTranslationsBulkDelete>>
>
export type PostTranslationsBulkDeleteMutationBody = PostTranslationsBulkDeleteBody
export type PostTranslationsBulkDeleteMutationError = unknown

/**
 * @summary Remove many translations
 */
export const usePostTranslationsBulkDelete = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postTranslationsBulkDelete>>,
      TError,
      { data: PostTranslationsBulkDeleteBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postTranslationsBulkDelete>>,
  TError,
  { data: PostTranslationsBulkDeleteBody },
  TContext
> => {
  return useMutation(getPostTranslationsBulkDeleteMutationOptions(options), queryClient)
}
export const getPostSmsSendManualUrl = () => {
  return `/api/v1/sms/send-manual`
}

/**
 * @summary Send a text to a list of numbers - this costs money
 */
export const postSmsSendManual = async (
  postSmsSendManualBody: PostSmsSendManualBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<ManualSmsSend> => {
  return customFetch<ManualSmsSend>(getPostSmsSendManualUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postSmsSendManualBody),
  })
}

export const getPostSmsSendManualMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSmsSendManual>>,
    TError,
    { data: PostSmsSendManualBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSmsSendManual>>,
  TError,
  { data: PostSmsSendManualBody },
  TContext
> => {
  const mutationKey = ['postSmsSendManual']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSmsSendManual>>,
    { data: PostSmsSendManualBody }
  > = (props) => {
    const { data } = props ?? {}

    return postSmsSendManual(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSmsSendManualMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSmsSendManual>>
>
export type PostSmsSendManualMutationBody = PostSmsSendManualBody
export type PostSmsSendManualMutationError = unknown

/**
 * @summary Send a text to a list of numbers - this costs money
 */
export const usePostSmsSendManual = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSmsSendManual>>,
      TError,
      { data: PostSmsSendManualBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSmsSendManual>>,
  TError,
  { data: PostSmsSendManualBody },
  TContext
> => {
  return useMutation(getPostSmsSendManualMutationOptions(options), queryClient)
}
export const getGetSettingsSmsUrl = () => {
  return `/api/v1/settings/sms`
}

/**
 * @summary The texting settings
 */
export const getSettingsSms = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<SmsSettings> => {
  return customFetch<SmsSettings>(getGetSettingsSmsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsSmsQueryKey = () => {
  return [`/api/v1/settings/sms`] as const
}

export const getGetSettingsSmsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsSms>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsSms>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsSmsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsSms>>> = ({ signal }) =>
    getSettingsSms({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsSms>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsSmsQueryResult = NonNullable<Awaited<ReturnType<typeof getSettingsSms>>>
export type GetSettingsSmsQueryError = unknown

export function useGetSettingsSms<
  TData = Awaited<ReturnType<typeof getSettingsSms>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsSms>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsSms>>,
          TError,
          Awaited<ReturnType<typeof getSettingsSms>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsSms<
  TData = Awaited<ReturnType<typeof getSettingsSms>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsSms>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsSms>>,
          TError,
          Awaited<ReturnType<typeof getSettingsSms>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsSms<
  TData = Awaited<ReturnType<typeof getSettingsSms>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsSms>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The texting settings
 */

export function useGetSettingsSms<
  TData = Awaited<ReturnType<typeof getSettingsSms>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsSms>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsSmsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostSettingsSmsUrl = () => {
  return `/api/v1/settings/sms`
}

/**
 * @summary Change the texting settings
 */
export const postSettingsSms = async (
  postSettingsSmsBody: PostSettingsSmsBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<SmsSettings> => {
  return customFetch<SmsSettings>(getPostSettingsSmsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postSettingsSmsBody),
  })
}

export const getPostSettingsSmsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSettingsSms>>,
    TError,
    { data: PostSettingsSmsBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSettingsSms>>,
  TError,
  { data: PostSettingsSmsBody },
  TContext
> => {
  const mutationKey = ['postSettingsSms']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSettingsSms>>,
    { data: PostSettingsSmsBody }
  > = (props) => {
    const { data } = props ?? {}

    return postSettingsSms(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSettingsSmsMutationResult = NonNullable<Awaited<ReturnType<typeof postSettingsSms>>>
export type PostSettingsSmsMutationBody = PostSettingsSmsBody
export type PostSettingsSmsMutationError = unknown

/**
 * @summary Change the texting settings
 */
export const usePostSettingsSms = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSettingsSms>>,
      TError,
      { data: PostSettingsSmsBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSettingsSms>>,
  TError,
  { data: PostSettingsSmsBody },
  TContext
> => {
  return useMutation(getPostSettingsSmsMutationOptions(options), queryClient)
}
export const getPostSettingsSmsTestUrl = () => {
  return `/api/v1/settings/sms/test`
}

/**
 * @summary Send one test text - this costs money
 */
export const postSettingsSmsTest = async (
  postSettingsSmsTestBody: PostSettingsSmsTestBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<SmsTestResult> => {
  return customFetch<SmsTestResult>(getPostSettingsSmsTestUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postSettingsSmsTestBody),
  })
}

export const getPostSettingsSmsTestMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSettingsSmsTest>>,
    TError,
    { data: PostSettingsSmsTestBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSettingsSmsTest>>,
  TError,
  { data: PostSettingsSmsTestBody },
  TContext
> => {
  const mutationKey = ['postSettingsSmsTest']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSettingsSmsTest>>,
    { data: PostSettingsSmsTestBody }
  > = (props) => {
    const { data } = props ?? {}

    return postSettingsSmsTest(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSettingsSmsTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSettingsSmsTest>>
>
export type PostSettingsSmsTestMutationBody = PostSettingsSmsTestBody
export type PostSettingsSmsTestMutationError = unknown

/**
 * @summary Send one test text - this costs money
 */
export const usePostSettingsSmsTest = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSettingsSmsTest>>,
      TError,
      { data: PostSettingsSmsTestBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSettingsSmsTest>>,
  TError,
  { data: PostSettingsSmsTestBody },
  TContext
> => {
  return useMutation(getPostSettingsSmsTestMutationOptions(options), queryClient)
}
export const getPostNewsletterSubscribeUrl = () => {
  return `/api/v1/newsletter/subscribe`
}

/**
 * @summary Subscribe to the newsletter
 */
export const postNewsletterSubscribe = async (
  postNewsletterSubscribeBody: PostNewsletterSubscribeBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<NewsletterSubscribed> => {
  return customFetch<NewsletterSubscribed>(getPostNewsletterSubscribeUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postNewsletterSubscribeBody),
  })
}

export const getPostNewsletterSubscribeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postNewsletterSubscribe>>,
    TError,
    { data: PostNewsletterSubscribeBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postNewsletterSubscribe>>,
  TError,
  { data: PostNewsletterSubscribeBody },
  TContext
> => {
  const mutationKey = ['postNewsletterSubscribe']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postNewsletterSubscribe>>,
    { data: PostNewsletterSubscribeBody }
  > = (props) => {
    const { data } = props ?? {}

    return postNewsletterSubscribe(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostNewsletterSubscribeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postNewsletterSubscribe>>
>
export type PostNewsletterSubscribeMutationBody = PostNewsletterSubscribeBody
export type PostNewsletterSubscribeMutationError = unknown

/**
 * @summary Subscribe to the newsletter
 */
export const usePostNewsletterSubscribe = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postNewsletterSubscribe>>,
      TError,
      { data: PostNewsletterSubscribeBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postNewsletterSubscribe>>,
  TError,
  { data: PostNewsletterSubscribeBody },
  TContext
> => {
  return useMutation(getPostNewsletterSubscribeMutationOptions(options), queryClient)
}
export const getPostMiniGamePlayUrl = () => {
  return `/api/v1/mini-game/play`
}

/**
 * @summary Play a mini-game
 */
export const postMiniGamePlay = async (
  postMiniGamePlayBody: PostMiniGamePlayBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<MiniGamePlayResult> => {
  return customFetch<MiniGamePlayResult>(getPostMiniGamePlayUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postMiniGamePlayBody),
  })
}

export const getPostMiniGamePlayMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMiniGamePlay>>,
    TError,
    { data: PostMiniGamePlayBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMiniGamePlay>>,
  TError,
  { data: PostMiniGamePlayBody },
  TContext
> => {
  const mutationKey = ['postMiniGamePlay']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMiniGamePlay>>,
    { data: PostMiniGamePlayBody }
  > = (props) => {
    const { data } = props ?? {}

    return postMiniGamePlay(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostMiniGamePlayMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMiniGamePlay>>
>
export type PostMiniGamePlayMutationBody = PostMiniGamePlayBody
export type PostMiniGamePlayMutationError = unknown

/**
 * @summary Play a mini-game
 */
export const usePostMiniGamePlay = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMiniGamePlay>>,
      TError,
      { data: PostMiniGamePlayBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postMiniGamePlay>>,
  TError,
  { data: PostMiniGamePlayBody },
  TContext
> => {
  return useMutation(getPostMiniGamePlayMutationOptions(options), queryClient)
}
export const getPostLoyaltyLeaderboardRunUrl = () => {
  return `/api/v1/loyalty/leaderboard/run`
}

/**
 * @summary Award the leaderboard prizes
 */
export const postLoyaltyLeaderboardRun = async (
  postLoyaltyLeaderboardRunBody?: PostLoyaltyLeaderboardRunBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<LeaderboardRunOutcome> => {
  return customFetch<LeaderboardRunOutcome>(getPostLoyaltyLeaderboardRunUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postLoyaltyLeaderboardRunBody),
  })
}

export const getPostLoyaltyLeaderboardRunMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postLoyaltyLeaderboardRun>>,
    TError,
    { data?: PostLoyaltyLeaderboardRunBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postLoyaltyLeaderboardRun>>,
  TError,
  { data?: PostLoyaltyLeaderboardRunBody },
  TContext
> => {
  const mutationKey = ['postLoyaltyLeaderboardRun']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postLoyaltyLeaderboardRun>>,
    { data?: PostLoyaltyLeaderboardRunBody }
  > = (props) => {
    const { data } = props ?? {}

    return postLoyaltyLeaderboardRun(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostLoyaltyLeaderboardRunMutationResult = NonNullable<
  Awaited<ReturnType<typeof postLoyaltyLeaderboardRun>>
>
export type PostLoyaltyLeaderboardRunMutationBody = PostLoyaltyLeaderboardRunBody | undefined
export type PostLoyaltyLeaderboardRunMutationError = unknown

/**
 * @summary Award the leaderboard prizes
 */
export const usePostLoyaltyLeaderboardRun = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postLoyaltyLeaderboardRun>>,
      TError,
      { data?: PostLoyaltyLeaderboardRunBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postLoyaltyLeaderboardRun>>,
  TError,
  { data?: PostLoyaltyLeaderboardRunBody },
  TContext
> => {
  return useMutation(getPostLoyaltyLeaderboardRunMutationOptions(options), queryClient)
}
export const getGetHomepageModulesUrl = () => {
  return `/api/v1/homepage-modules`
}

/**
 * @summary The homepage blocks, in order
 */
export const getHomepageModules = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<HomepageModule[]> => {
  return customFetch<HomepageModule[]>(getGetHomepageModulesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetHomepageModulesQueryKey = () => {
  return [`/api/v1/homepage-modules`] as const
}

export const getGetHomepageModulesQueryOptions = <
  TData = Awaited<ReturnType<typeof getHomepageModules>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHomepageModules>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetHomepageModulesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHomepageModules>>> = ({ signal }) =>
    getHomepageModules({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getHomepageModules>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHomepageModulesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHomepageModules>>
>
export type GetHomepageModulesQueryError = unknown

export function useGetHomepageModules<
  TData = Awaited<ReturnType<typeof getHomepageModules>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHomepageModules>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHomepageModules>>,
          TError,
          Awaited<ReturnType<typeof getHomepageModules>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHomepageModules<
  TData = Awaited<ReturnType<typeof getHomepageModules>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getHomepageModules>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHomepageModules>>,
          TError,
          Awaited<ReturnType<typeof getHomepageModules>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHomepageModules<
  TData = Awaited<ReturnType<typeof getHomepageModules>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHomepageModules>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The homepage blocks, in order
 */

export function useGetHomepageModules<
  TData = Awaited<ReturnType<typeof getHomepageModules>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHomepageModules>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetHomepageModulesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostHomepageModulesUrl = () => {
  return `/api/v1/homepage-modules`
}

/**
 * @summary Add another copy of a block
 */
export const postHomepageModules = async (
  postHomepageModulesBody: PostHomepageModulesBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<HomepageModule> => {
  return customFetch<HomepageModule>(getPostHomepageModulesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postHomepageModulesBody),
  })
}

export const getPostHomepageModulesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postHomepageModules>>,
    TError,
    { data: PostHomepageModulesBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postHomepageModules>>,
  TError,
  { data: PostHomepageModulesBody },
  TContext
> => {
  const mutationKey = ['postHomepageModules']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postHomepageModules>>,
    { data: PostHomepageModulesBody }
  > = (props) => {
    const { data } = props ?? {}

    return postHomepageModules(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostHomepageModulesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postHomepageModules>>
>
export type PostHomepageModulesMutationBody = PostHomepageModulesBody
export type PostHomepageModulesMutationError = unknown

/**
 * @summary Add another copy of a block
 */
export const usePostHomepageModules = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postHomepageModules>>,
      TError,
      { data: PostHomepageModulesBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postHomepageModules>>,
  TError,
  { data: PostHomepageModulesBody },
  TContext
> => {
  return useMutation(getPostHomepageModulesMutationOptions(options), queryClient)
}
export const getPostHomepageModulesSeedUrl = () => {
  return `/api/v1/homepage-modules/seed`
}

/**
 * @summary Put back any missing default block
 */
export const postHomepageModulesSeed = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<HomepageModulesSeeded> => {
  return customFetch<HomepageModulesSeeded>(getPostHomepageModulesSeedUrl(), {
    ...options,
    method: 'POST',
  })
}

export const getPostHomepageModulesSeedMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postHomepageModulesSeed>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postHomepageModulesSeed>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postHomepageModulesSeed']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postHomepageModulesSeed>>,
    void
  > = () => {
    return postHomepageModulesSeed(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostHomepageModulesSeedMutationResult = NonNullable<
  Awaited<ReturnType<typeof postHomepageModulesSeed>>
>

export type PostHomepageModulesSeedMutationError = unknown

/**
 * @summary Put back any missing default block
 */
export const usePostHomepageModulesSeed = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postHomepageModulesSeed>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postHomepageModulesSeed>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getPostHomepageModulesSeedMutationOptions(options), queryClient)
}
export const getGetCampaignsUrl = () => {
  return `/api/v1/campaigns`
}

/**
 * @summary Every campaign, with its last run
 */
export const getCampaigns = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<Campaign[]> => {
  return customFetch<Campaign[]>(getGetCampaignsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetCampaignsQueryKey = () => {
  return [`/api/v1/campaigns`] as const
}

export const getGetCampaignsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCampaigns>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaigns>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCampaignsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaigns>>> = ({ signal }) =>
    getCampaigns({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCampaigns>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampaignsQueryResult = NonNullable<Awaited<ReturnType<typeof getCampaigns>>>
export type GetCampaignsQueryError = unknown

export function useGetCampaigns<TData = Awaited<ReturnType<typeof getCampaigns>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaigns>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaigns>>,
          TError,
          Awaited<ReturnType<typeof getCampaigns>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaigns<TData = Awaited<ReturnType<typeof getCampaigns>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaigns>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaigns>>,
          TError,
          Awaited<ReturnType<typeof getCampaigns>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaigns<TData = Awaited<ReturnType<typeof getCampaigns>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaigns>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every campaign, with its last run
 */

export function useGetCampaigns<TData = Awaited<ReturnType<typeof getCampaigns>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaigns>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCampaignsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostCampaignsUrl = () => {
  return `/api/v1/campaigns`
}

/**
 * @summary Add a campaign of a type that already has one
 */
export const postCampaigns = async (
  postCampaignsBody: PostCampaignsBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<Campaign> => {
  return customFetch<Campaign>(getPostCampaignsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postCampaignsBody),
  })
}

export const getPostCampaignsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCampaigns>>,
    TError,
    { data: PostCampaignsBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCampaigns>>,
  TError,
  { data: PostCampaignsBody },
  TContext
> => {
  const mutationKey = ['postCampaigns']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCampaigns>>,
    { data: PostCampaignsBody }
  > = (props) => {
    const { data } = props ?? {}

    return postCampaigns(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCampaignsMutationResult = NonNullable<Awaited<ReturnType<typeof postCampaigns>>>
export type PostCampaignsMutationBody = PostCampaignsBody
export type PostCampaignsMutationError = unknown

/**
 * @summary Add a campaign of a type that already has one
 */
export const usePostCampaigns = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCampaigns>>,
      TError,
      { data: PostCampaignsBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCampaigns>>,
  TError,
  { data: PostCampaignsBody },
  TContext
> => {
  return useMutation(getPostCampaignsMutationOptions(options), queryClient)
}
export const getPostCampaignsTypeRunUrl = (type: string) => {
  return `/api/v1/campaigns/${type}/run`
}

/**
 * @summary Run a campaign now
 */
export const postCampaignsTypeRun = async (
  type: string,
  postCampaignsTypeRunBody?: PostCampaignsTypeRunBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<CampaignRunOutcome> => {
  return customFetch<CampaignRunOutcome>(getPostCampaignsTypeRunUrl(type), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postCampaignsTypeRunBody),
  })
}

export const getPostCampaignsTypeRunMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCampaignsTypeRun>>,
    TError,
    { type: string; data?: PostCampaignsTypeRunBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCampaignsTypeRun>>,
  TError,
  { type: string; data?: PostCampaignsTypeRunBody },
  TContext
> => {
  const mutationKey = ['postCampaignsTypeRun']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCampaignsTypeRun>>,
    { type: string; data?: PostCampaignsTypeRunBody }
  > = (props) => {
    const { type, data } = props ?? {}

    return postCampaignsTypeRun(type, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCampaignsTypeRunMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCampaignsTypeRun>>
>
export type PostCampaignsTypeRunMutationBody = PostCampaignsTypeRunBody | undefined
export type PostCampaignsTypeRunMutationError = unknown

/**
 * @summary Run a campaign now
 */
export const usePostCampaignsTypeRun = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCampaignsTypeRun>>,
      TError,
      { type: string; data?: PostCampaignsTypeRunBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCampaignsTypeRun>>,
  TError,
  { type: string; data?: PostCampaignsTypeRunBody },
  TContext
> => {
  return useMutation(getPostCampaignsTypeRunMutationOptions(options), queryClient)
}
export const getPostCampaignsWheelSpinUrl = () => {
  return `/api/v1/campaigns/wheel/spin`
}

/**
 * @summary Spin the wheel
 */
export const postCampaignsWheelSpin = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<WheelSpinResult> => {
  return customFetch<WheelSpinResult>(getPostCampaignsWheelSpinUrl(), {
    ...options,
    method: 'POST',
  })
}

export const getPostCampaignsWheelSpinMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCampaignsWheelSpin>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCampaignsWheelSpin>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postCampaignsWheelSpin']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCampaignsWheelSpin>>,
    void
  > = () => {
    return postCampaignsWheelSpin(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCampaignsWheelSpinMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCampaignsWheelSpin>>
>

export type PostCampaignsWheelSpinMutationError = unknown

/**
 * @summary Spin the wheel
 */
export const usePostCampaignsWheelSpin = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCampaignsWheelSpin>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCampaignsWheelSpin>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getPostCampaignsWheelSpinMutationOptions(options), queryClient)
}
export const getPostCampaignsIdIdRunUrl = (id: number) => {
  return `/api/v1/campaigns/id/${id}/run`
}

/**
 * @summary Run one campaign by id
 */
export const postCampaignsIdIdRun = async (
  id: number,
  postCampaignsIdIdRunBody?: PostCampaignsIdIdRunBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<CampaignRunOutcome> => {
  return customFetch<CampaignRunOutcome>(getPostCampaignsIdIdRunUrl(id), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postCampaignsIdIdRunBody),
  })
}

export const getPostCampaignsIdIdRunMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCampaignsIdIdRun>>,
    TError,
    { id: number; data?: PostCampaignsIdIdRunBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCampaignsIdIdRun>>,
  TError,
  { id: number; data?: PostCampaignsIdIdRunBody },
  TContext
> => {
  const mutationKey = ['postCampaignsIdIdRun']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCampaignsIdIdRun>>,
    { id: number; data?: PostCampaignsIdIdRunBody }
  > = (props) => {
    const { id, data } = props ?? {}

    return postCampaignsIdIdRun(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCampaignsIdIdRunMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCampaignsIdIdRun>>
>
export type PostCampaignsIdIdRunMutationBody = PostCampaignsIdIdRunBody | undefined
export type PostCampaignsIdIdRunMutationError = unknown

/**
 * @summary Run one campaign by id
 */
export const usePostCampaignsIdIdRun = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCampaignsIdIdRun>>,
      TError,
      { id: number; data?: PostCampaignsIdIdRunBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCampaignsIdIdRun>>,
  TError,
  { id: number; data?: PostCampaignsIdIdRunBody },
  TContext
> => {
  return useMutation(getPostCampaignsIdIdRunMutationOptions(options), queryClient)
}
export const getDeleteTranslationsIdUrl = (id: number) => {
  return `/api/v1/translations/${id}`
}

/**
 * @summary Remove a translation
 */
export const deleteTranslationsId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<TranslationRemoved> => {
  return customFetch<TranslationRemoved>(getDeleteTranslationsIdUrl(id), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteTranslationsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTranslationsId>>,
    TError,
    { id: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTranslationsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteTranslationsId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTranslationsId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {}

    return deleteTranslationsId(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteTranslationsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTranslationsId>>
>

export type DeleteTranslationsIdMutationError = unknown

/**
 * @summary Remove a translation
 */
export const useDeleteTranslationsId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteTranslationsId>>,
      TError,
      { id: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteTranslationsId>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteTranslationsIdMutationOptions(options), queryClient)
}
export const getPatchTranslationsIdUrl = (id: number) => {
  return `/api/v1/translations/${id}`
}

/**
 * @summary Type a translation by hand
 */
export const patchTranslationsId = async (
  id: number,
  patchTranslationsIdBody: PatchTranslationsIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<TranslationOverridden> => {
  return customFetch<TranslationOverridden>(getPatchTranslationsIdUrl(id), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchTranslationsIdBody),
  })
}

export const getPatchTranslationsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchTranslationsId>>,
    TError,
    { id: number; data: PatchTranslationsIdBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchTranslationsId>>,
  TError,
  { id: number; data: PatchTranslationsIdBody },
  TContext
> => {
  const mutationKey = ['patchTranslationsId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchTranslationsId>>,
    { id: number; data: PatchTranslationsIdBody }
  > = (props) => {
    const { id, data } = props ?? {}

    return patchTranslationsId(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchTranslationsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchTranslationsId>>
>
export type PatchTranslationsIdMutationBody = PatchTranslationsIdBody
export type PatchTranslationsIdMutationError = unknown

/**
 * @summary Type a translation by hand
 */
export const usePatchTranslationsId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchTranslationsId>>,
      TError,
      { id: number; data: PatchTranslationsIdBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchTranslationsId>>,
  TError,
  { id: number; data: PatchTranslationsIdBody },
  TContext
> => {
  return useMutation(getPatchTranslationsIdMutationOptions(options), queryClient)
}
export const getPatchCampaignsTypeUrl = (type: string) => {
  return `/api/v1/campaigns/${type}`
}

/**
 * @summary Change a campaign
 */
export const patchCampaignsType = async (
  type: string,
  patchCampaignsTypeBody: PatchCampaignsTypeBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<CampaignWritten> => {
  return customFetch<CampaignWritten>(getPatchCampaignsTypeUrl(type), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchCampaignsTypeBody),
  })
}

export const getPatchCampaignsTypeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchCampaignsType>>,
    TError,
    { type: string; data: PatchCampaignsTypeBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchCampaignsType>>,
  TError,
  { type: string; data: PatchCampaignsTypeBody },
  TContext
> => {
  const mutationKey = ['patchCampaignsType']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchCampaignsType>>,
    { type: string; data: PatchCampaignsTypeBody }
  > = (props) => {
    const { type, data } = props ?? {}

    return patchCampaignsType(type, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchCampaignsTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchCampaignsType>>
>
export type PatchCampaignsTypeMutationBody = PatchCampaignsTypeBody
export type PatchCampaignsTypeMutationError = unknown

/**
 * @summary Change a campaign
 */
export const usePatchCampaignsType = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchCampaignsType>>,
      TError,
      { type: string; data: PatchCampaignsTypeBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchCampaignsType>>,
  TError,
  { type: string; data: PatchCampaignsTypeBody },
  TContext
> => {
  return useMutation(getPatchCampaignsTypeMutationOptions(options), queryClient)
}
export const getGetCampaignsWheelUrl = () => {
  return `/api/v1/campaigns/wheel`
}

/**
 * @summary The customer's wheel
 */
export const getCampaignsWheel = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerWheel> => {
  return customFetch<CustomerWheel>(getGetCampaignsWheelUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetCampaignsWheelQueryKey = () => {
  return [`/api/v1/campaigns/wheel`] as const
}

export const getGetCampaignsWheelQueryOptions = <
  TData = Awaited<ReturnType<typeof getCampaignsWheel>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignsWheel>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCampaignsWheelQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignsWheel>>> = ({ signal }) =>
    getCampaignsWheel({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCampaignsWheel>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampaignsWheelQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCampaignsWheel>>
>
export type GetCampaignsWheelQueryError = unknown

export function useGetCampaignsWheel<
  TData = Awaited<ReturnType<typeof getCampaignsWheel>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignsWheel>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignsWheel>>,
          TError,
          Awaited<ReturnType<typeof getCampaignsWheel>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignsWheel<
  TData = Awaited<ReturnType<typeof getCampaignsWheel>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignsWheel>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignsWheel>>,
          TError,
          Awaited<ReturnType<typeof getCampaignsWheel>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignsWheel<
  TData = Awaited<ReturnType<typeof getCampaignsWheel>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignsWheel>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The customer's wheel
 */

export function useGetCampaignsWheel<
  TData = Awaited<ReturnType<typeof getCampaignsWheel>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignsWheel>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCampaignsWheelQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPatchCampaignsWheelUrl = () => {
  return `/api/v1/campaigns/wheel`
}

/**
 * @summary Change the wheel
 */
export const patchCampaignsWheel = async (
  patchCampaignsWheelBody: PatchCampaignsWheelBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<WheelSettings> => {
  return customFetch<WheelSettings>(getPatchCampaignsWheelUrl(), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchCampaignsWheelBody),
  })
}

export const getPatchCampaignsWheelMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchCampaignsWheel>>,
    TError,
    { data: PatchCampaignsWheelBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchCampaignsWheel>>,
  TError,
  { data: PatchCampaignsWheelBody },
  TContext
> => {
  const mutationKey = ['patchCampaignsWheel']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchCampaignsWheel>>,
    { data: PatchCampaignsWheelBody }
  > = (props) => {
    const { data } = props ?? {}

    return patchCampaignsWheel(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchCampaignsWheelMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchCampaignsWheel>>
>
export type PatchCampaignsWheelMutationBody = PatchCampaignsWheelBody
export type PatchCampaignsWheelMutationError = unknown

/**
 * @summary Change the wheel
 */
export const usePatchCampaignsWheel = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchCampaignsWheel>>,
      TError,
      { data: PatchCampaignsWheelBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchCampaignsWheel>>,
  TError,
  { data: PatchCampaignsWheelBody },
  TContext
> => {
  return useMutation(getPatchCampaignsWheelMutationOptions(options), queryClient)
}
export const getGetCampaignsSendCapUrl = () => {
  return `/api/v1/campaigns/send-cap`
}

/**
 * The cap counts rows in `campaign_sends`, which is written by this system only. A franchise migrated from the old one starts with that log **empty** while its campaign counters already total thousands - measured here, 0 sends against 1 655 counted - because the old system kept no per-recipient log. So the cap and the number a campaign screen shows are counting different things, and the cap genuinely applies from the migration onward rather than retroactively.
 *
 * `updatedAt` is null until somebody first changes the cap.
 * @summary The per-customer daily send cap
 */
export const getCampaignsSendCap = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<CampaignSendCap> => {
  return customFetch<CampaignSendCap>(getGetCampaignsSendCapUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetCampaignsSendCapQueryKey = () => {
  return [`/api/v1/campaigns/send-cap`] as const
}

export const getGetCampaignsSendCapQueryOptions = <
  TData = Awaited<ReturnType<typeof getCampaignsSendCap>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignsSendCap>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCampaignsSendCapQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignsSendCap>>> = ({ signal }) =>
    getCampaignsSendCap({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCampaignsSendCap>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampaignsSendCapQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCampaignsSendCap>>
>
export type GetCampaignsSendCapQueryError = unknown

export function useGetCampaignsSendCap<
  TData = Awaited<ReturnType<typeof getCampaignsSendCap>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCampaignsSendCap>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignsSendCap>>,
          TError,
          Awaited<ReturnType<typeof getCampaignsSendCap>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignsSendCap<
  TData = Awaited<ReturnType<typeof getCampaignsSendCap>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCampaignsSendCap>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignsSendCap>>,
          TError,
          Awaited<ReturnType<typeof getCampaignsSendCap>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignsSendCap<
  TData = Awaited<ReturnType<typeof getCampaignsSendCap>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignsSendCap>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The per-customer daily send cap
 */

export function useGetCampaignsSendCap<
  TData = Awaited<ReturnType<typeof getCampaignsSendCap>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignsSendCap>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCampaignsSendCapQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPatchCampaignsSendCapUrl = () => {
  return `/api/v1/campaigns/send-cap`
}

/**
 * Takes a partial body. `isActive: true` with a resulting cap of 0 is refused: the runner skips the check when the cap is not positive, so *on, 0 per day* is **no cap at all** rather than *nobody receives anything*, which is how it reads.
 * @summary Change the per-customer daily send cap
 */
export const patchCampaignsSendCap = async (
  patchCampaignsSendCapBody: PatchCampaignsSendCapBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<CampaignSendCap> => {
  return customFetch<CampaignSendCap>(getPatchCampaignsSendCapUrl(), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchCampaignsSendCapBody),
  })
}

export const getPatchCampaignsSendCapMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchCampaignsSendCap>>,
    TError,
    { data: PatchCampaignsSendCapBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchCampaignsSendCap>>,
  TError,
  { data: PatchCampaignsSendCapBody },
  TContext
> => {
  const mutationKey = ['patchCampaignsSendCap']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchCampaignsSendCap>>,
    { data: PatchCampaignsSendCapBody }
  > = (props) => {
    const { data } = props ?? {}

    return patchCampaignsSendCap(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchCampaignsSendCapMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchCampaignsSendCap>>
>
export type PatchCampaignsSendCapMutationBody = PatchCampaignsSendCapBody
export type PatchCampaignsSendCapMutationError = unknown

/**
 * @summary Change the per-customer daily send cap
 */
export const usePatchCampaignsSendCap = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchCampaignsSendCap>>,
      TError,
      { data: PatchCampaignsSendCapBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchCampaignsSendCap>>,
  TError,
  { data: PatchCampaignsSendCapBody },
  TContext
> => {
  return useMutation(getPatchCampaignsSendCapMutationOptions(options), queryClient)
}
export const getGetCampaignsIdIdUrl = (id: number) => {
  return `/api/v1/campaigns/id/${id}`
}

/**
 * @summary One campaign by id
 */
export const getCampaignsIdId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<Campaign> => {
  return customFetch<Campaign>(getGetCampaignsIdIdUrl(id), {
    ...options,
    method: 'GET',
  })
}

export const getGetCampaignsIdIdQueryKey = (id: number) => {
  return [`/api/v1/campaigns/id/${id}`] as const
}

export const getGetCampaignsIdIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCampaignsIdId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignsIdId>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCampaignsIdIdQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignsIdId>>> = ({ signal }) =>
    getCampaignsIdId(id, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getCampaignsIdId>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetCampaignsIdIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCampaignsIdId>>>
export type GetCampaignsIdIdQueryError = unknown

export function useGetCampaignsIdId<
  TData = Awaited<ReturnType<typeof getCampaignsIdId>>,
  TError = unknown,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignsIdId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignsIdId>>,
          TError,
          Awaited<ReturnType<typeof getCampaignsIdId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignsIdId<
  TData = Awaited<ReturnType<typeof getCampaignsIdId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignsIdId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignsIdId>>,
          TError,
          Awaited<ReturnType<typeof getCampaignsIdId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignsIdId<
  TData = Awaited<ReturnType<typeof getCampaignsIdId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignsIdId>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One campaign by id
 */

export function useGetCampaignsIdId<
  TData = Awaited<ReturnType<typeof getCampaignsIdId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignsIdId>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCampaignsIdIdQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getDeleteCampaignsIdIdUrl = (id: number) => {
  return `/api/v1/campaigns/id/${id}`
}

/**
 * @summary Delete one campaign by id
 */
export const deleteCampaignsIdId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<CampaignDeleted> => {
  return customFetch<CampaignDeleted>(getDeleteCampaignsIdIdUrl(id), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteCampaignsIdIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCampaignsIdId>>,
    TError,
    { id: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCampaignsIdId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteCampaignsIdId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCampaignsIdId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {}

    return deleteCampaignsIdId(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteCampaignsIdIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCampaignsIdId>>
>

export type DeleteCampaignsIdIdMutationError = unknown

/**
 * @summary Delete one campaign by id
 */
export const useDeleteCampaignsIdId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCampaignsIdId>>,
      TError,
      { id: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCampaignsIdId>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteCampaignsIdIdMutationOptions(options), queryClient)
}
export const getPatchCampaignsIdIdUrl = (id: number) => {
  return `/api/v1/campaigns/id/${id}`
}

/**
 * @summary Change one campaign by id
 */
export const patchCampaignsIdId = async (
  id: number,
  patchCampaignsIdIdBody: PatchCampaignsIdIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<CampaignWritten> => {
  return customFetch<CampaignWritten>(getPatchCampaignsIdIdUrl(id), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchCampaignsIdIdBody),
  })
}

export const getPatchCampaignsIdIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchCampaignsIdId>>,
    TError,
    { id: number; data: PatchCampaignsIdIdBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchCampaignsIdId>>,
  TError,
  { id: number; data: PatchCampaignsIdIdBody },
  TContext
> => {
  const mutationKey = ['patchCampaignsIdId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchCampaignsIdId>>,
    { id: number; data: PatchCampaignsIdIdBody }
  > = (props) => {
    const { id, data } = props ?? {}

    return patchCampaignsIdId(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchCampaignsIdIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchCampaignsIdId>>
>
export type PatchCampaignsIdIdMutationBody = PatchCampaignsIdIdBody
export type PatchCampaignsIdIdMutationError = unknown

/**
 * @summary Change one campaign by id
 */
export const usePatchCampaignsIdId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchCampaignsIdId>>,
      TError,
      { id: number; data: PatchCampaignsIdIdBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchCampaignsIdId>>,
  TError,
  { id: number; data: PatchCampaignsIdIdBody },
  TContext
> => {
  return useMutation(getPatchCampaignsIdIdMutationOptions(options), queryClient)
}
export const getGetTranslationsUrl = (params?: GetTranslationsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/translations?${stringifiedParams}`
    : `/api/v1/translations`
}

/**
 * @summary The translation memory
 */
export const getTranslations = async (
  params?: GetTranslationsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<TranslationPage> => {
  return customFetch<TranslationPage>(getGetTranslationsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetTranslationsQueryKey = (params?: GetTranslationsParams) => {
  return [`/api/v1/translations`, ...(params ? [params] : [])] as const
}

export const getGetTranslationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTranslations>>,
  TError = unknown,
>(
  params?: GetTranslationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTranslations>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetTranslationsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTranslations>>> = ({ signal }) =>
    getTranslations(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTranslations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTranslationsQueryResult = NonNullable<Awaited<ReturnType<typeof getTranslations>>>
export type GetTranslationsQueryError = unknown

export function useGetTranslations<
  TData = Awaited<ReturnType<typeof getTranslations>>,
  TError = unknown,
>(
  params: undefined | GetTranslationsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTranslations>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTranslations>>,
          TError,
          Awaited<ReturnType<typeof getTranslations>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTranslations<
  TData = Awaited<ReturnType<typeof getTranslations>>,
  TError = unknown,
>(
  params?: GetTranslationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTranslations>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTranslations>>,
          TError,
          Awaited<ReturnType<typeof getTranslations>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTranslations<
  TData = Awaited<ReturnType<typeof getTranslations>>,
  TError = unknown,
>(
  params?: GetTranslationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTranslations>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The translation memory
 */

export function useGetTranslations<
  TData = Awaited<ReturnType<typeof getTranslations>>,
  TError = unknown,
>(
  params?: GetTranslationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTranslations>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTranslationsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetTranslationsStatsUrl = () => {
  return `/api/v1/translations/stats`
}

/**
 * @summary How much is translated and how much is left
 */
export const getTranslationsStats = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<TranslationStats> => {
  return customFetch<TranslationStats>(getGetTranslationsStatsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetTranslationsStatsQueryKey = () => {
  return [`/api/v1/translations/stats`] as const
}

export const getGetTranslationsStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTranslationsStats>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTranslationsStats>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetTranslationsStatsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTranslationsStats>>> = ({ signal }) =>
    getTranslationsStats({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTranslationsStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTranslationsStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTranslationsStats>>
>
export type GetTranslationsStatsQueryError = unknown

export function useGetTranslationsStats<
  TData = Awaited<ReturnType<typeof getTranslationsStats>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTranslationsStats>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTranslationsStats>>,
          TError,
          Awaited<ReturnType<typeof getTranslationsStats>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTranslationsStats<
  TData = Awaited<ReturnType<typeof getTranslationsStats>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTranslationsStats>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTranslationsStats>>,
          TError,
          Awaited<ReturnType<typeof getTranslationsStats>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTranslationsStats<
  TData = Awaited<ReturnType<typeof getTranslationsStats>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTranslationsStats>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary How much is translated and how much is left
 */

export function useGetTranslationsStats<
  TData = Awaited<ReturnType<typeof getTranslationsStats>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTranslationsStats>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTranslationsStatsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetTranslationsNamespacesUrl = () => {
  return `/api/v1/translations/namespaces`
}

/**
 * @summary The namespaces the translation memory holds
 */
export const getTranslationsNamespaces = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<string[]> => {
  return customFetch<string[]>(getGetTranslationsNamespacesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetTranslationsNamespacesQueryKey = () => {
  return [`/api/v1/translations/namespaces`] as const
}

export const getGetTranslationsNamespacesQueryOptions = <
  TData = Awaited<ReturnType<typeof getTranslationsNamespaces>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getTranslationsNamespaces>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetTranslationsNamespacesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTranslationsNamespaces>>> = ({
    signal,
  }) => getTranslationsNamespaces({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTranslationsNamespaces>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTranslationsNamespacesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTranslationsNamespaces>>
>
export type GetTranslationsNamespacesQueryError = unknown

export function useGetTranslationsNamespaces<
  TData = Awaited<ReturnType<typeof getTranslationsNamespaces>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTranslationsNamespaces>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTranslationsNamespaces>>,
          TError,
          Awaited<ReturnType<typeof getTranslationsNamespaces>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTranslationsNamespaces<
  TData = Awaited<ReturnType<typeof getTranslationsNamespaces>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTranslationsNamespaces>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTranslationsNamespaces>>,
          TError,
          Awaited<ReturnType<typeof getTranslationsNamespaces>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTranslationsNamespaces<
  TData = Awaited<ReturnType<typeof getTranslationsNamespaces>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTranslationsNamespaces>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The namespaces the translation memory holds
 */

export function useGetTranslationsNamespaces<
  TData = Awaited<ReturnType<typeof getTranslationsNamespaces>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTranslationsNamespaces>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTranslationsNamespacesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetTranslationsJobIdUrl = (id: string) => {
  return `/api/v1/translations/job/${id}`
}

/**
 * @summary How a sweep is getting on
 */
export const getTranslationsJobId = async (
  id: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<TranslationSweepStatus> => {
  return customFetch<TranslationSweepStatus>(getGetTranslationsJobIdUrl(id), {
    ...options,
    method: 'GET',
  })
}

export const getGetTranslationsJobIdQueryKey = (id: string) => {
  return [`/api/v1/translations/job/${id}`] as const
}

export const getGetTranslationsJobIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getTranslationsJobId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTranslationsJobId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetTranslationsJobIdQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTranslationsJobId>>> = ({ signal }) =>
    getTranslationsJobId(id, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getTranslationsJobId>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetTranslationsJobIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTranslationsJobId>>
>
export type GetTranslationsJobIdQueryError = unknown

export function useGetTranslationsJobId<
  TData = Awaited<ReturnType<typeof getTranslationsJobId>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTranslationsJobId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTranslationsJobId>>,
          TError,
          Awaited<ReturnType<typeof getTranslationsJobId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTranslationsJobId<
  TData = Awaited<ReturnType<typeof getTranslationsJobId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTranslationsJobId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTranslationsJobId>>,
          TError,
          Awaited<ReturnType<typeof getTranslationsJobId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTranslationsJobId<
  TData = Awaited<ReturnType<typeof getTranslationsJobId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTranslationsJobId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary How a sweep is getting on
 */

export function useGetTranslationsJobId<
  TData = Awaited<ReturnType<typeof getTranslationsJobId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTranslationsJobId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTranslationsJobIdQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetTranslationsDictUrl = (params?: GetTranslationsDictParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/translations/dict?${stringifiedParams}`
    : `/api/v1/translations/dict`
}

/**
 * @summary The whole dictionary for one language
 */
export const getTranslationsDict = async (
  params?: GetTranslationsDictParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<TranslationDictionaryResponse> => {
  return customFetch<TranslationDictionaryResponse>(getGetTranslationsDictUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetTranslationsDictQueryKey = (params?: GetTranslationsDictParams) => {
  return [`/api/v1/translations/dict`, ...(params ? [params] : [])] as const
}

export const getGetTranslationsDictQueryOptions = <
  TData = Awaited<ReturnType<typeof getTranslationsDict>>,
  TError = unknown,
>(
  params?: GetTranslationsDictParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTranslationsDict>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetTranslationsDictQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTranslationsDict>>> = ({ signal }) =>
    getTranslationsDict(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTranslationsDict>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTranslationsDictQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTranslationsDict>>
>
export type GetTranslationsDictQueryError = unknown

export function useGetTranslationsDict<
  TData = Awaited<ReturnType<typeof getTranslationsDict>>,
  TError = unknown,
>(
  params: undefined | GetTranslationsDictParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTranslationsDict>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTranslationsDict>>,
          TError,
          Awaited<ReturnType<typeof getTranslationsDict>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTranslationsDict<
  TData = Awaited<ReturnType<typeof getTranslationsDict>>,
  TError = unknown,
>(
  params?: GetTranslationsDictParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTranslationsDict>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTranslationsDict>>,
          TError,
          Awaited<ReturnType<typeof getTranslationsDict>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTranslationsDict<
  TData = Awaited<ReturnType<typeof getTranslationsDict>>,
  TError = unknown,
>(
  params?: GetTranslationsDictParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTranslationsDict>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The whole dictionary for one language
 */

export function useGetTranslationsDict<
  TData = Awaited<ReturnType<typeof getTranslationsDict>>,
  TError = unknown,
>(
  params?: GetTranslationsDictParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTranslationsDict>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTranslationsDictQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetPublicGoogleRatingUrl = () => {
  return `/api/v1/public/google-rating`
}

/**
 * @summary The restaurant's Google rating
 */
export const getPublicGoogleRating = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GoogleRating> => {
  return customFetch<GoogleRating>(getGetPublicGoogleRatingUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetPublicGoogleRatingQueryKey = () => {
  return [`/api/v1/public/google-rating`] as const
}

export const getGetPublicGoogleRatingQueryOptions = <
  TData = Awaited<ReturnType<typeof getPublicGoogleRating>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicGoogleRating>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetPublicGoogleRatingQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicGoogleRating>>> = ({ signal }) =>
    getPublicGoogleRating({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPublicGoogleRating>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicGoogleRatingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPublicGoogleRating>>
>
export type GetPublicGoogleRatingQueryError = unknown

export function useGetPublicGoogleRating<
  TData = Awaited<ReturnType<typeof getPublicGoogleRating>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPublicGoogleRating>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicGoogleRating>>,
          TError,
          Awaited<ReturnType<typeof getPublicGoogleRating>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicGoogleRating<
  TData = Awaited<ReturnType<typeof getPublicGoogleRating>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPublicGoogleRating>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicGoogleRating>>,
          TError,
          Awaited<ReturnType<typeof getPublicGoogleRating>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicGoogleRating<
  TData = Awaited<ReturnType<typeof getPublicGoogleRating>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPublicGoogleRating>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The restaurant's Google rating
 */

export function useGetPublicGoogleRating<
  TData = Awaited<ReturnType<typeof getPublicGoogleRating>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPublicGoogleRating>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPublicGoogleRatingQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetNewsletterSubscribersUrl = (params?: GetNewsletterSubscribersParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/newsletter/subscribers?${stringifiedParams}`
    : `/api/v1/newsletter/subscribers`
}

/**
 * @summary Everybody subscribed
 */
export const getNewsletterSubscribers = async (
  params?: GetNewsletterSubscribersParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<NewsletterSubscriberPage> => {
  return customFetch<NewsletterSubscriberPage>(getGetNewsletterSubscribersUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetNewsletterSubscribersQueryKey = (params?: GetNewsletterSubscribersParams) => {
  return [`/api/v1/newsletter/subscribers`, ...(params ? [params] : [])] as const
}

export const getGetNewsletterSubscribersQueryOptions = <
  TData = Awaited<ReturnType<typeof getNewsletterSubscribers>>,
  TError = unknown,
>(
  params?: GetNewsletterSubscribersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNewsletterSubscribers>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetNewsletterSubscribersQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNewsletterSubscribers>>> = ({
    signal,
  }) => getNewsletterSubscribers(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNewsletterSubscribers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNewsletterSubscribersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNewsletterSubscribers>>
>
export type GetNewsletterSubscribersQueryError = unknown

export function useGetNewsletterSubscribers<
  TData = Awaited<ReturnType<typeof getNewsletterSubscribers>>,
  TError = unknown,
>(
  params: undefined | GetNewsletterSubscribersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNewsletterSubscribers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewsletterSubscribers>>,
          TError,
          Awaited<ReturnType<typeof getNewsletterSubscribers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewsletterSubscribers<
  TData = Awaited<ReturnType<typeof getNewsletterSubscribers>>,
  TError = unknown,
>(
  params?: GetNewsletterSubscribersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNewsletterSubscribers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewsletterSubscribers>>,
          TError,
          Awaited<ReturnType<typeof getNewsletterSubscribers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewsletterSubscribers<
  TData = Awaited<ReturnType<typeof getNewsletterSubscribers>>,
  TError = unknown,
>(
  params?: GetNewsletterSubscribersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNewsletterSubscribers>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Everybody subscribed
 */

export function useGetNewsletterSubscribers<
  TData = Awaited<ReturnType<typeof getNewsletterSubscribers>>,
  TError = unknown,
>(
  params?: GetNewsletterSubscribersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNewsletterSubscribers>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetNewsletterSubscribersQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetMiniGameStatusUrl = () => {
  return `/api/v1/mini-game/status`
}

/**
 * @summary Whether the customer may play today
 */
export const getMiniGameStatus = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<MiniGameStatus> => {
  return customFetch<MiniGameStatus>(getGetMiniGameStatusUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetMiniGameStatusQueryKey = () => {
  return [`/api/v1/mini-game/status`] as const
}

export const getGetMiniGameStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getMiniGameStatus>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMiniGameStatus>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetMiniGameStatusQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMiniGameStatus>>> = ({ signal }) =>
    getMiniGameStatus({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMiniGameStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMiniGameStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMiniGameStatus>>
>
export type GetMiniGameStatusQueryError = unknown

export function useGetMiniGameStatus<
  TData = Awaited<ReturnType<typeof getMiniGameStatus>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMiniGameStatus>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMiniGameStatus>>,
          TError,
          Awaited<ReturnType<typeof getMiniGameStatus>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMiniGameStatus<
  TData = Awaited<ReturnType<typeof getMiniGameStatus>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMiniGameStatus>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMiniGameStatus>>,
          TError,
          Awaited<ReturnType<typeof getMiniGameStatus>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMiniGameStatus<
  TData = Awaited<ReturnType<typeof getMiniGameStatus>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMiniGameStatus>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Whether the customer may play today
 */

export function useGetMiniGameStatus<
  TData = Awaited<ReturnType<typeof getMiniGameStatus>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMiniGameStatus>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMiniGameStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetMiniGameStatsUrl = (params?: GetMiniGameStatsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/mini-game/stats?${stringifiedParams}`
    : `/api/v1/mini-game/stats`
}

/**
 * @summary How the mini-games are going
 */
export const getMiniGameStats = async (
  params?: GetMiniGameStatsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<MiniGameStats> => {
  return customFetch<MiniGameStats>(getGetMiniGameStatsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetMiniGameStatsQueryKey = (params?: GetMiniGameStatsParams) => {
  return [`/api/v1/mini-game/stats`, ...(params ? [params] : [])] as const
}

export const getGetMiniGameStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMiniGameStats>>,
  TError = unknown,
>(
  params?: GetMiniGameStatsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMiniGameStats>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetMiniGameStatsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMiniGameStats>>> = ({ signal }) =>
    getMiniGameStats(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMiniGameStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMiniGameStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getMiniGameStats>>>
export type GetMiniGameStatsQueryError = unknown

export function useGetMiniGameStats<
  TData = Awaited<ReturnType<typeof getMiniGameStats>>,
  TError = unknown,
>(
  params: undefined | GetMiniGameStatsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMiniGameStats>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMiniGameStats>>,
          TError,
          Awaited<ReturnType<typeof getMiniGameStats>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMiniGameStats<
  TData = Awaited<ReturnType<typeof getMiniGameStats>>,
  TError = unknown,
>(
  params?: GetMiniGameStatsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMiniGameStats>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMiniGameStats>>,
          TError,
          Awaited<ReturnType<typeof getMiniGameStats>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMiniGameStats<
  TData = Awaited<ReturnType<typeof getMiniGameStats>>,
  TError = unknown,
>(
  params?: GetMiniGameStatsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMiniGameStats>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary How the mini-games are going
 */

export function useGetMiniGameStats<
  TData = Awaited<ReturnType<typeof getMiniGameStats>>,
  TError = unknown,
>(
  params?: GetMiniGameStatsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMiniGameStats>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMiniGameStatsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetLoyaltyLeaderboardUrl = (params?: GetLoyaltyLeaderboardParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/loyalty/leaderboard?${stringifiedParams}`
    : `/api/v1/loyalty/leaderboard`
}

/**
 * @summary The month's biggest spenders
 */
export const getLoyaltyLeaderboard = async (
  params?: GetLoyaltyLeaderboardParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<Leaderboard> => {
  return customFetch<Leaderboard>(getGetLoyaltyLeaderboardUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetLoyaltyLeaderboardQueryKey = (params?: GetLoyaltyLeaderboardParams) => {
  return [`/api/v1/loyalty/leaderboard`, ...(params ? [params] : [])] as const
}

export const getGetLoyaltyLeaderboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getLoyaltyLeaderboard>>,
  TError = unknown,
>(
  params?: GetLoyaltyLeaderboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyLeaderboard>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetLoyaltyLeaderboardQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoyaltyLeaderboard>>> = ({ signal }) =>
    getLoyaltyLeaderboard(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLoyaltyLeaderboard>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoyaltyLeaderboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLoyaltyLeaderboard>>
>
export type GetLoyaltyLeaderboardQueryError = unknown

export function useGetLoyaltyLeaderboard<
  TData = Awaited<ReturnType<typeof getLoyaltyLeaderboard>>,
  TError = unknown,
>(
  params: undefined | GetLoyaltyLeaderboardParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyLeaderboard>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoyaltyLeaderboard>>,
          TError,
          Awaited<ReturnType<typeof getLoyaltyLeaderboard>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoyaltyLeaderboard<
  TData = Awaited<ReturnType<typeof getLoyaltyLeaderboard>>,
  TError = unknown,
>(
  params?: GetLoyaltyLeaderboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyLeaderboard>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoyaltyLeaderboard>>,
          TError,
          Awaited<ReturnType<typeof getLoyaltyLeaderboard>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoyaltyLeaderboard<
  TData = Awaited<ReturnType<typeof getLoyaltyLeaderboard>>,
  TError = unknown,
>(
  params?: GetLoyaltyLeaderboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyLeaderboard>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The month's biggest spenders
 */

export function useGetLoyaltyLeaderboard<
  TData = Awaited<ReturnType<typeof getLoyaltyLeaderboard>>,
  TError = unknown,
>(
  params?: GetLoyaltyLeaderboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyLeaderboard>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetLoyaltyLeaderboardQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetLoyaltyLeaderboardHistoryUrl = () => {
  return `/api/v1/loyalty/leaderboard/history`
}

/**
 * @summary Past months' leaderboard winners
 */
export const getLoyaltyLeaderboardHistory = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<LeaderboardHistory> => {
  return customFetch<LeaderboardHistory>(getGetLoyaltyLeaderboardHistoryUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetLoyaltyLeaderboardHistoryQueryKey = () => {
  return [`/api/v1/loyalty/leaderboard/history`] as const
}

export const getGetLoyaltyLeaderboardHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getLoyaltyLeaderboardHistory>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyLeaderboardHistory>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetLoyaltyLeaderboardHistoryQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoyaltyLeaderboardHistory>>> = ({
    signal,
  }) => getLoyaltyLeaderboardHistory({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLoyaltyLeaderboardHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoyaltyLeaderboardHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLoyaltyLeaderboardHistory>>
>
export type GetLoyaltyLeaderboardHistoryQueryError = unknown

export function useGetLoyaltyLeaderboardHistory<
  TData = Awaited<ReturnType<typeof getLoyaltyLeaderboardHistory>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyLeaderboardHistory>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoyaltyLeaderboardHistory>>,
          TError,
          Awaited<ReturnType<typeof getLoyaltyLeaderboardHistory>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoyaltyLeaderboardHistory<
  TData = Awaited<ReturnType<typeof getLoyaltyLeaderboardHistory>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyLeaderboardHistory>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoyaltyLeaderboardHistory>>,
          TError,
          Awaited<ReturnType<typeof getLoyaltyLeaderboardHistory>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoyaltyLeaderboardHistory<
  TData = Awaited<ReturnType<typeof getLoyaltyLeaderboardHistory>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyLeaderboardHistory>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Past months' leaderboard winners
 */

export function useGetLoyaltyLeaderboardHistory<
  TData = Awaited<ReturnType<typeof getLoyaltyLeaderboardHistory>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyLeaderboardHistory>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetLoyaltyLeaderboardHistoryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetCmsPagesUrl = () => {
  return `/api/v1/cms-pages`
}

/**
 * @summary The pages a visitor may see
 */
export const getCmsPages = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<CmsPageSummary[]> => {
  return customFetch<CmsPageSummary[]>(getGetCmsPagesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetCmsPagesQueryKey = () => {
  return [`/api/v1/cms-pages`] as const
}

export const getGetCmsPagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCmsPages>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsPages>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCmsPagesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCmsPages>>> = ({ signal }) =>
    getCmsPages({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCmsPages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCmsPagesQueryResult = NonNullable<Awaited<ReturnType<typeof getCmsPages>>>
export type GetCmsPagesQueryError = unknown

export function useGetCmsPages<TData = Awaited<ReturnType<typeof getCmsPages>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsPages>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCmsPages>>,
          TError,
          Awaited<ReturnType<typeof getCmsPages>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCmsPages<TData = Awaited<ReturnType<typeof getCmsPages>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsPages>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCmsPages>>,
          TError,
          Awaited<ReturnType<typeof getCmsPages>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCmsPages<TData = Awaited<ReturnType<typeof getCmsPages>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsPages>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The pages a visitor may see
 */

export function useGetCmsPages<TData = Awaited<ReturnType<typeof getCmsPages>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsPages>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCmsPagesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetCmsPagesAdminAllUrl = () => {
  return `/api/v1/cms-pages/admin/all`
}

/**
 * @summary Every page, drafts included
 */
export const getCmsPagesAdminAll = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<CmsPage[]> => {
  return customFetch<CmsPage[]>(getGetCmsPagesAdminAllUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetCmsPagesAdminAllQueryKey = () => {
  return [`/api/v1/cms-pages/admin/all`] as const
}

export const getGetCmsPagesAdminAllQueryOptions = <
  TData = Awaited<ReturnType<typeof getCmsPagesAdminAll>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsPagesAdminAll>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCmsPagesAdminAllQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCmsPagesAdminAll>>> = ({ signal }) =>
    getCmsPagesAdminAll({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCmsPagesAdminAll>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCmsPagesAdminAllQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCmsPagesAdminAll>>
>
export type GetCmsPagesAdminAllQueryError = unknown

export function useGetCmsPagesAdminAll<
  TData = Awaited<ReturnType<typeof getCmsPagesAdminAll>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCmsPagesAdminAll>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCmsPagesAdminAll>>,
          TError,
          Awaited<ReturnType<typeof getCmsPagesAdminAll>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCmsPagesAdminAll<
  TData = Awaited<ReturnType<typeof getCmsPagesAdminAll>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCmsPagesAdminAll>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCmsPagesAdminAll>>,
          TError,
          Awaited<ReturnType<typeof getCmsPagesAdminAll>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCmsPagesAdminAll<
  TData = Awaited<ReturnType<typeof getCmsPagesAdminAll>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsPagesAdminAll>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every page, drafts included
 */

export function useGetCmsPagesAdminAll<
  TData = Awaited<ReturnType<typeof getCmsPagesAdminAll>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsPagesAdminAll>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCmsPagesAdminAllQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetCampaignsTypeRunsUrl = (type: string) => {
  return `/api/v1/campaigns/${type}/runs`
}

/**
 * @summary The last twenty runs of one campaign
 */
export const getCampaignsTypeRuns = async (
  type: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<CampaignRunRow[]> => {
  return customFetch<CampaignRunRow[]>(getGetCampaignsTypeRunsUrl(type), {
    ...options,
    method: 'GET',
  })
}

export const getGetCampaignsTypeRunsQueryKey = (type: string) => {
  return [`/api/v1/campaigns/${type}/runs`] as const
}

export const getGetCampaignsTypeRunsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCampaignsTypeRuns>>,
  TError = unknown,
>(
  type: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCampaignsTypeRuns>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCampaignsTypeRunsQueryKey(type)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignsTypeRuns>>> = ({ signal }) =>
    getCampaignsTypeRuns(type, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: type !== null && type !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getCampaignsTypeRuns>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetCampaignsTypeRunsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCampaignsTypeRuns>>
>
export type GetCampaignsTypeRunsQueryError = unknown

export function useGetCampaignsTypeRuns<
  TData = Awaited<ReturnType<typeof getCampaignsTypeRuns>>,
  TError = unknown,
>(
  type: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCampaignsTypeRuns>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignsTypeRuns>>,
          TError,
          Awaited<ReturnType<typeof getCampaignsTypeRuns>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignsTypeRuns<
  TData = Awaited<ReturnType<typeof getCampaignsTypeRuns>>,
  TError = unknown,
>(
  type: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCampaignsTypeRuns>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignsTypeRuns>>,
          TError,
          Awaited<ReturnType<typeof getCampaignsTypeRuns>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignsTypeRuns<
  TData = Awaited<ReturnType<typeof getCampaignsTypeRuns>>,
  TError = unknown,
>(
  type: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCampaignsTypeRuns>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The last twenty runs of one campaign
 */

export function useGetCampaignsTypeRuns<
  TData = Awaited<ReturnType<typeof getCampaignsTypeRuns>>,
  TError = unknown,
>(
  type: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCampaignsTypeRuns>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCampaignsTypeRunsQueryOptions(type, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetCampaignsWheelAdminUrl = () => {
  return `/api/v1/campaigns/wheel/admin`
}

/**
 * @summary The wheel's settings
 */
export const getCampaignsWheelAdmin = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<WheelSettings> => {
  return customFetch<WheelSettings>(getGetCampaignsWheelAdminUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetCampaignsWheelAdminQueryKey = () => {
  return [`/api/v1/campaigns/wheel/admin`] as const
}

export const getGetCampaignsWheelAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof getCampaignsWheelAdmin>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getCampaignsWheelAdmin>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCampaignsWheelAdminQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignsWheelAdmin>>> = ({ signal }) =>
    getCampaignsWheelAdmin({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCampaignsWheelAdmin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampaignsWheelAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCampaignsWheelAdmin>>
>
export type GetCampaignsWheelAdminQueryError = unknown

export function useGetCampaignsWheelAdmin<
  TData = Awaited<ReturnType<typeof getCampaignsWheelAdmin>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCampaignsWheelAdmin>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignsWheelAdmin>>,
          TError,
          Awaited<ReturnType<typeof getCampaignsWheelAdmin>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignsWheelAdmin<
  TData = Awaited<ReturnType<typeof getCampaignsWheelAdmin>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCampaignsWheelAdmin>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignsWheelAdmin>>,
          TError,
          Awaited<ReturnType<typeof getCampaignsWheelAdmin>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignsWheelAdmin<
  TData = Awaited<ReturnType<typeof getCampaignsWheelAdmin>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCampaignsWheelAdmin>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The wheel's settings
 */

export function useGetCampaignsWheelAdmin<
  TData = Awaited<ReturnType<typeof getCampaignsWheelAdmin>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCampaignsWheelAdmin>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCampaignsWheelAdminQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetCampaignsIdIdRunsUrl = (id: number) => {
  return `/api/v1/campaigns/id/${id}/runs`
}

/**
 * @summary The last twenty runs of one campaign by id
 */
export const getCampaignsIdIdRuns = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<CampaignRunRow[]> => {
  return customFetch<CampaignRunRow[]>(getGetCampaignsIdIdRunsUrl(id), {
    ...options,
    method: 'GET',
  })
}

export const getGetCampaignsIdIdRunsQueryKey = (id: number) => {
  return [`/api/v1/campaigns/id/${id}/runs`] as const
}

export const getGetCampaignsIdIdRunsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCampaignsIdIdRuns>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCampaignsIdIdRuns>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCampaignsIdIdRunsQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignsIdIdRuns>>> = ({ signal }) =>
    getCampaignsIdIdRuns(id, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getCampaignsIdIdRuns>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetCampaignsIdIdRunsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCampaignsIdIdRuns>>
>
export type GetCampaignsIdIdRunsQueryError = unknown

export function useGetCampaignsIdIdRuns<
  TData = Awaited<ReturnType<typeof getCampaignsIdIdRuns>>,
  TError = unknown,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCampaignsIdIdRuns>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignsIdIdRuns>>,
          TError,
          Awaited<ReturnType<typeof getCampaignsIdIdRuns>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignsIdIdRuns<
  TData = Awaited<ReturnType<typeof getCampaignsIdIdRuns>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCampaignsIdIdRuns>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignsIdIdRuns>>,
          TError,
          Awaited<ReturnType<typeof getCampaignsIdIdRuns>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignsIdIdRuns<
  TData = Awaited<ReturnType<typeof getCampaignsIdIdRuns>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCampaignsIdIdRuns>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The last twenty runs of one campaign by id
 */

export function useGetCampaignsIdIdRuns<
  TData = Awaited<ReturnType<typeof getCampaignsIdIdRuns>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCampaignsIdIdRuns>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCampaignsIdIdRunsQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetCampaignsHappyHoursPublicUrl = () => {
  return `/api/v1/campaigns/happy-hours/public`
}

/**
 * @summary Whether happy hours are running
 */
export const getCampaignsHappyHoursPublic = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<HappyHoursPublic> => {
  return customFetch<HappyHoursPublic>(getGetCampaignsHappyHoursPublicUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetCampaignsHappyHoursPublicQueryKey = () => {
  return [`/api/v1/campaigns/happy-hours/public`] as const
}

export const getGetCampaignsHappyHoursPublicQueryOptions = <
  TData = Awaited<ReturnType<typeof getCampaignsHappyHoursPublic>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getCampaignsHappyHoursPublic>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCampaignsHappyHoursPublicQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignsHappyHoursPublic>>> = ({
    signal,
  }) => getCampaignsHappyHoursPublic({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCampaignsHappyHoursPublic>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampaignsHappyHoursPublicQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCampaignsHappyHoursPublic>>
>
export type GetCampaignsHappyHoursPublicQueryError = unknown

export function useGetCampaignsHappyHoursPublic<
  TData = Awaited<ReturnType<typeof getCampaignsHappyHoursPublic>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCampaignsHappyHoursPublic>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignsHappyHoursPublic>>,
          TError,
          Awaited<ReturnType<typeof getCampaignsHappyHoursPublic>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignsHappyHoursPublic<
  TData = Awaited<ReturnType<typeof getCampaignsHappyHoursPublic>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCampaignsHappyHoursPublic>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignsHappyHoursPublic>>,
          TError,
          Awaited<ReturnType<typeof getCampaignsHappyHoursPublic>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignsHappyHoursPublic<
  TData = Awaited<ReturnType<typeof getCampaignsHappyHoursPublic>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCampaignsHappyHoursPublic>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Whether happy hours are running
 */

export function useGetCampaignsHappyHoursPublic<
  TData = Awaited<ReturnType<typeof getCampaignsHappyHoursPublic>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCampaignsHappyHoursPublic>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCampaignsHappyHoursPublicQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetCampaignsActivePromoUrl = () => {
  return `/api/v1/campaigns/active-promo`
}

/**
 * @summary The promotions a checkout must apply right now
 */
export const getCampaignsActivePromo = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<ActivePromo> => {
  return customFetch<ActivePromo>(getGetCampaignsActivePromoUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetCampaignsActivePromoQueryKey = () => {
  return [`/api/v1/campaigns/active-promo`] as const
}

export const getGetCampaignsActivePromoQueryOptions = <
  TData = Awaited<ReturnType<typeof getCampaignsActivePromo>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getCampaignsActivePromo>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCampaignsActivePromoQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignsActivePromo>>> = ({
    signal,
  }) => getCampaignsActivePromo({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCampaignsActivePromo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampaignsActivePromoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCampaignsActivePromo>>
>
export type GetCampaignsActivePromoQueryError = unknown

export function useGetCampaignsActivePromo<
  TData = Awaited<ReturnType<typeof getCampaignsActivePromo>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCampaignsActivePromo>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignsActivePromo>>,
          TError,
          Awaited<ReturnType<typeof getCampaignsActivePromo>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignsActivePromo<
  TData = Awaited<ReturnType<typeof getCampaignsActivePromo>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCampaignsActivePromo>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignsActivePromo>>,
          TError,
          Awaited<ReturnType<typeof getCampaignsActivePromo>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignsActivePromo<
  TData = Awaited<ReturnType<typeof getCampaignsActivePromo>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCampaignsActivePromo>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The promotions a checkout must apply right now
 */

export function useGetCampaignsActivePromo<
  TData = Awaited<ReturnType<typeof getCampaignsActivePromo>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCampaignsActivePromo>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCampaignsActivePromoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getDeleteNewsletterSubscribersIdUrl = (id: number) => {
  return `/api/v1/newsletter/subscribers/${id}`
}

/**
 * @summary Remove a subscriber
 */
export const deleteNewsletterSubscribersId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<NewsletterSubscriberRemoved> => {
  return customFetch<NewsletterSubscriberRemoved>(getDeleteNewsletterSubscribersIdUrl(id), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteNewsletterSubscribersIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNewsletterSubscribersId>>,
    TError,
    { id: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteNewsletterSubscribersId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteNewsletterSubscribersId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteNewsletterSubscribersId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {}

    return deleteNewsletterSubscribersId(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteNewsletterSubscribersIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteNewsletterSubscribersId>>
>

export type DeleteNewsletterSubscribersIdMutationError = unknown

/**
 * @summary Remove a subscriber
 */
export const useDeleteNewsletterSubscribersId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteNewsletterSubscribersId>>,
      TError,
      { id: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteNewsletterSubscribersId>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteNewsletterSubscribersIdMutationOptions(options), queryClient)
}
